<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat v-if="facility_name">
                <v-card-title class="primary white--text headline">
                    Key Savings Metrics
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 v-if="data">
                        <vue-plotly show-export :data="data" :layout="layout" :options="options" ref="plotly"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat v-if="facility_name">
                <v-layout row wrap>
                    <v-flex xs12 v-if="data3">
                        <vue-plotly show-export :data="data3" :layout="layout3" :options="options3" ref="plotly"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat v-if="facility_name">
                <v-layout row wrap>
                    <v-flex xs12 v-if="data4">
                        <vue-plotly show-export :data="data4" :layout="layout4" :options="options4" ref="plotly"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {callAPI,getCOP} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import moment from 'moment'
    import _ from 'lodash'
    export default {
        name: 'KeySavings',
        components: {VuePlotly},
        computed: {
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            },
            facility_name() {
                return this.$store.state.pointsListStore.pointsList.facility_name
            },

            oatVar(){
                if(this.$store.state.pointsListStore.pointsList.facility_name==="CRP"){
                    return 'Temperature';
                } else {
                    return 'Outdoor_Temperature';
                }

            },
            cutOff(){
                if(this.$store.state.pointsListStore.pointsList.facility_name==="CRP"){
                    return "2019-11-26 00:00:00";
                } else {
                    return "2019-09-18 00:00:00";
                }

            },
            layout(){
                return ({
                    title: 'Energy Comsumption',
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Average outdoor air temperature (°C)',
                        range: [15, 35]
                    },
                    yaxis: {
                        range: this.$store.state.pointsListStore.pointsList.facility_name === "SHT" ? [0, 6000] : "tozero",
                        title: 'Total energy consumption (kWh)',
                        rangemode: 'tozero'
                    }
                })
            },
            layout3() {
                return ({
                    title:'COP',
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Average outdoor air temperature (°C)',
                        range: [15, 35]
                    },
                    yaxis: {
                        title: 'COP'
                    }
                })
            },
            layout4() {
                return ({
                    title:'CHWS',
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Average outdoor air temperature (°C)',
                        range: [15, 35]
                    },
                    yaxis: {
                        title: 'Temperature (°C)',
                    }
                })
            }
        },
        data () {
            return {
                range: {start: '2019-09-25', end: '2019-10-01'},
                loading:false,
                forcedBlue:["2019-10-31 00:00:00","2019-10-29 00:00:00"],
                data:null,
                colorMap:{
                    "ACPC-1":"rgba(255, 127, 14,0.5)",
                    "ACPC-2":"rgba(214, 39, 40,0.5)",
                    "ACPC-3":"rgba(44, 160, 44, 0.5)",
                    "ACPC-4":"rgba(31, 119, 180,0.5)",
                    "ACPC-5": "rgba(148, 103, 189,0.5)",
                    "ACPC-6": "rgba(140, 86, 75,0.5)",
                    "ACPC-7": "rgba(227, 119, 194,0.5)",
                    "ACPC-8": "rgba(127, 127, 127,0.5)",
                    "ACPC-9": "rgba(188, 189, 34,0.5)",
                    "Chiller1": "rgba(255, 127, 14,0.5)",
                    "Chiller2": "rgba(214, 39, 40,0.5)",
                    "Chiller3": "rgba(44, 160, 44, 0.5)",
                    "Chiller4": "rgba(31, 119, 180,0.5)",
                    "Chiller5": "rgba(148, 103, 189,0.5)",
                    "Chiller6": "rgba(140, 86, 75,0.5)",
                    "Chiller7": "rgba(227, 119, 194,0.5)",
                    "Chiller8": "rgba(127, 127, 127,0.5)",
                    "Chiller9": "rgba(188, 189, 34,0.5)",
                    "Chiller_1A": "rgba(255, 127, 14,0.5)",
                    "Chiller_1B": "rgba(214, 39, 40,0.5)",
                    "Chiller_2": "rgba(44, 160, 44, 0.5)",
                    "Chiller_3": "rgba(31, 119, 180,0.5)",
                    "Chiller_4": "rgba(148, 103, 189,0.5)",
                    "Chiller_5": "rgba(140, 86, 75,0.5)",
                    "Chiller_6": "rgba(227, 119, 194,0.5)",
                    "Chiller_7": "rgba(127, 127, 127,0.5)",
                },
                data3:null,
                data4:null,
                options: {},
                options3: {},
                options4: {},
            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    ar3.push(ar1[i] + ar2[i]);
                return ar3;
            },
            findLineByLeastSquares(values_x, values_y) {
                //TODO : optimise this the ES6 way and remove variable re-usage, this is very procedural old-style JS
                let sum_x = 0;
                let sum_y = 0;
                let sum_xy = 0;
                let sum_xx = 0;
                let count = 0;
                let x = 0;
                let y = 0;
                let values_length = values_x.length;
                if (values_length != values_y.length) {
                    throw new Error('The parameters values_x and values_y need to have same size!');
                }
                if (values_length === 0) {
                    return [ [], [] ];
                }
                for (let v = 0; v < values_length; v++) {
                    x = values_x[v];
                    y = values_y[v];
                    sum_x += x;
                    sum_y += y;
                    sum_xx += x*x;
                    sum_xy += x*y;
                    count++;
                }
                let m = (count*sum_xy - sum_x*sum_y) / (count*sum_xx - sum_x*sum_x);
                let b = (sum_y/count) - (m*sum_x)/count;
                let result_values_x = [];
                let result_values_y = [];
                for (let v = 0; v < values_length; v++) {
                    x = values_x[v];
                    y = x * m + b;
                    result_values_x.push(x);
                    result_values_y.push(y);
                }
                return [result_values_x, result_values_y];
            }
        },
        mounted() {
            let me=this;
            let rangeStart = _.get(this.$route.query,'rangeStart', null)
            if(!rangeStart){
                rangeStart=this.facility_name=="SHT" ? "2019-08-27" : "2019-10-17"
            }
            let rangeEnd =  _.get(this.$route.query,'rangeEnd', moment().subtract(1, "days").format('YYYY-MM-DD'))
            me.loading=true;
            let promises=[];
            let timestamp=null;
            let totalPower=null;
            let cop=null;
            let chws=null;
            let avgTemp=null;

            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                if(equip.equipment_type==='chiller'){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['Comp_Power']
                        }
                    ))
                } else if(equip.equipment_type==='pump'&&this.$store.state.pointsListStore.pointsList.facility_name!=="CRP"){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['KW']
                        }
                    ))
                }
            }
            promises.push(callAPI('data/',
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment_name': 'Weather',
                    'agg': 'D',
                    'agg_op': 'mean',
                    'date_range':[rangeStart, rangeEnd+" 23:59"],
                    'sensor_names': [me.oatVar]
                }
            ))
            promises.push(getCOP({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                from_date: rangeStart,
                to_date: rangeEnd+" 23:59",
                agg: 'D',
                agg_op: 'mean',
            }))
            promises.push(callAPI('data/',
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment_name': this.$store.state.pointsListStore.pointsList.facility_name=="CRP" ? 'Header' : 'Chiller Header',
                    'agg': 'D',
                    'agg_op': 'mean',
                    'remove_zero':true,
                    'date_range':[rangeStart, rangeEnd+" 23:59"],
                    'sensor_names': ['Main_Supply_Temp']
                }
            ))


            Promise.all(promises).then(function(reses) {
                for (let res of reses){
                    if(res.COP){
                        cop=res.COP
                    } else {
                        if(!timestamp){
                            timestamp=res.data.timestamp;
                        }
                        if(res.data[me.oatVar]){
                            avgTemp=res.data[me.oatVar];
                        } else if(res.data['Main_Supply_Temp']){
                            chws=res.data['Main_Supply_Temp'];
                        } else {
                            if(!totalPower){
                                if(res.data['Comp_Power']){
                                    totalPower=res.data['Comp_Power'];
                                } else if (res.data['KW']){
                                    totalPower=res.data['KW'];
                                }
                            } else {
                                if(res.data['Comp_Power']){
                                    totalPower=me.addArrays(totalPower,res.data['Comp_Power'])
                                } else if (res.data['KW']){
                                    totalPower=me.addArrays(totalPower,res.data['KW'])
                                }
                            }
                        }
                    }


                }
                let preAvgTemp=[];
                let postAvgTemp=[];
                let preTotalPower=[];
                let postTotalPower=[];
                let preLabels=[];
                let postLabels=[];
                let preCOP=[];
                let postCOP=[];
                let preCHWS=[];
                let postCHWS=[];
                for (let k in timestamp){
                    if(timestamp[k]<=me.cutOff||(me.forcedBlue.includes(timestamp[k])&&me.$store.state.pointsListStore.pointsList.facility_name=="SHT" )){
                        preAvgTemp.push(avgTemp[k]);
                        preTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        preLabels.push(timestamp[k].substring(0, 10));
                        preCOP.push(cop[k]);
                        preCHWS.push(chws[k]);
                    } else {
                        postAvgTemp.push(avgTemp[k]);
                        postTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        postLabels.push(timestamp[k].substring(0, 10));
                        postCOP.push(cop[k]);
                        postCHWS.push(chws[k]);
                    }
                }
                let trendBefore=me.findLineByLeastSquares(preAvgTemp,preTotalPower)
                let trendAfter=me.findLineByLeastSquares(postAvgTemp,postTotalPower)
                let trendBeforeCOP=me.findLineByLeastSquares(preAvgTemp,preCOP)
                let trendAfterCOP=me.findLineByLeastSquares(postAvgTemp,postCOP)
                let trendBeforeCHWS=me.findLineByLeastSquares(preAvgTemp,preCHWS)
                let trendAfterCHWS=me.findLineByLeastSquares(postAvgTemp,postCHWS)
                me.data = [
                    {
                        x: preAvgTemp,
                        y: preTotalPower,
                        type: 'scattergl',
                        mode: 'markers',
                        name:"Before optimisation",
                        hovertext:preLabels,
                        marker: {
                            color: 'rgb(31, 119, 180)',
                        }
                    },
                    {
                        x: trendBefore[0],
                        y: trendBefore[1],
                        type: 'scattergl',
                        name:"Before optimisation trend",
                        mode: 'lines',
                        line: {
                            color: 'rgb(31, 119, 180)',
                            width: 2,
                        }
                    },
                    {
                        x: postAvgTemp,
                        y: postTotalPower,
                        type: 'scattergl',
                        mode: 'markers',
                        name:"After optimisation",
                        hovertext:postLabels,
                        marker: {
                            color: 'rgb(255, 127, 14)',
                        }
                    },
                    {
                        x: trendAfter[0],
                        y: trendAfter[1],
                        type: 'scattergl',
                        name: "After optimisation trend",
                        mode: 'lines',
                        line: {
                            color: 'rgb(255, 127, 14)',
                            width: 2,
                        }
                    },
                ]

                me.data3 = [
                    {
                        x: preAvgTemp,
                        y: preCOP,
                        type: 'scattergl',
                        mode: 'markers',
                        name:"Before optimisation",
                        hovertext:preLabels,
                        marker: {
                            color: 'rgb(31, 119, 180)',
                        }
                    },
                    {
                        x: trendBeforeCOP[0],
                        y: trendBeforeCOP[1],
                        type: 'scattergl',
                        name:"Before optimisation trend",
                        mode: 'lines',
                        line: {
                            color: 'rgb(31, 119, 180)',
                            width: 2,
                        }
                    },
                    {
                        x: postAvgTemp,
                        y: postCOP,
                        type: 'scattergl',
                        mode: 'markers',
                        name:"After optimisation",
                        hovertext:postLabels,
                        marker: {
                            color: 'rgb(255, 127, 14)',
                        }
                    },
                    {
                        x: trendAfterCOP[0],
                        y: trendAfterCOP[1],
                        type: 'scattergl',
                        name: "After optimisation trend",
                        mode: 'lines',
                        line: {
                            color: 'rgb(255, 127, 14)',
                            width: 2,
                        }
                    },
                ]

                me.data4 = [
                    {
                        x: preAvgTemp,
                        y: preCHWS,
                        type: 'scattergl',
                        mode: 'markers',
                        name:"Before optimisation",
                        hovertext:preLabels,
                        marker: {
                            color: 'rgb(31, 119, 180)',
                        }
                    },
                    {
                        x: trendBeforeCHWS[0],
                        y: trendBeforeCHWS[1],
                        type: 'scattergl',
                        name:"Before optimisation trend",
                        mode: 'lines',
                        line: {
                            color: 'rgb(31, 119, 180)',
                            width: 2,
                        }
                    },
                    {
                        x: postAvgTemp,
                        y: postCHWS,
                        type: 'scattergl',
                        mode: 'markers',
                        name:"After optimisation",
                        hovertext:postLabels,
                        marker: {
                            color: 'rgb(255, 127, 14)',
                        }
                    },
                    {
                        x: trendAfterCHWS[0],
                        y: trendAfterCHWS[1],
                        type: 'scattergl',
                        name: "After optimisation trend",
                        mode: 'lines',
                        line: {
                            color: 'rgb(255, 127, 14)',
                            width: 2,
                        }
                    },
                ]
                me.loading=false;
            });




        }


    }
</script>
<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
</style>
